import { ActivityIndicator } from '@hfzq/crab-react';
import classNames from 'classnames';
import React, { Suspense, FC } from 'react';
import { Mutex } from '@src/helper/mutex';
import styles from './index.module.less';

export const ReactEChartsLazy = React.lazy(loadReactLazyCharts);

const reactLazyMutex = new Mutex();
/**
 * 加载 react-echarts
 * 不允许并发执行
 */
export async function loadReactLazyCharts() {
  await reactLazyMutex.acquire();
  try {
    return await import('./react-echarts');
  } finally {
    reactLazyMutex.release();
  }
}

type ReactEChartsLazySuspenseProps = {
  children: React.ReactNode;
  loading?: React.ReactNode;
} & React.HtmlHTMLAttributes<HTMLDivElement>;

export const ReactEChartsLazySuspense: FC<ReactEChartsLazySuspenseProps> = ({
  children,
  className,
  loading = <ReactEChartsloading />,
  ...props
}) => (
  <div className={classNames(styles.echartsLazySuspenseContainer, className)} {...props}>
    <Suspense fallback={<div className={styles.loadingContainer}>{loading}</div>}>{children}</Suspense>
  </div>
);

const ReactEChartsloading: FC = () => <ActivityIndicator />;
